import { render, staticRenderFns } from "./EventHandler.vue?vue&type=template&id=e09d9972&"
import script from "./EventHandler.vue?vue&type=script&lang=js&"
export * from "./EventHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports